import React, { Dispatch } from "react";
import { ActionIcon, Avatar, Modal, Text } from "rizzui";
import { Button } from "@/components/ui/button";
import { IoIosClose } from "react-icons/io";
import { FileInput } from "rizzui";
import useAxiosAuth from "@/hooks/fetch/useAxiosAuth";
import UploadZone from "@/components/ui/file-upload/upload-zone";
import { apis } from "@/static/apis/apis";
import postData from "@/functions/postData";

export default function UploadFile({
  onClose,
  isOpen,
  ...props
}: {
  onClose: () => void;
  isOpen: boolean;
  [key: string]: any;
}) {
  const axios = useAxiosAuth(true, false, true);

  return (
    <Modal onClose={onClose} isOpen={isOpen} size="lg">
      <ActionIcon
        size="lg"
        variant="text"
        onClick={() => onClose()}
        className="text-5xl m-3"
      >
        <IoIosClose />
      </ActionIcon>
      <div className="m-auto px-7 pb-8">
        {/* <FileInput
          label="فایل مورد نظر را آپلود کنید"
          size="xl"
          onChange={(event) => {
            event.preventDefault();
            const form = new FormData();
            if (event.target.files !== null)
              // event.target.files.forEach((file: any) => {
              form.append("image", event.target.files[0]);
            // });
            form.append("chatroom", props.id);
            postData(apis.message.create, axios, form, undefined, true);
          }}
        /> */}
        <UploadZone
          label="فایل مورد نظر را آپلود کنید"
          name="coverPhoto"
          setValue={() => {}}
          getValues={() => {}}
          className="col-span-full"
          id={props.id}
          afterDone={onClose}
        />
      </div>
    </Modal>
  );
}
